// extracted by mini-css-extract-plugin
module.exports = {"box":"stat-boxes-module--box--1gb1X"};